import { render, staticRenderFns } from "./ActivateInterbankPayment.vue?vue&type=template&id=0c16e5ea&"
import script from "./ActivateInterbankPayment.vue?vue&type=script&lang=js&"
export * from "./ActivateInterbankPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports